var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup30487(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.811,
    height: 20.578,
    viewBox: "0 0 16.811 20.578",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30487",
    "data-name": "Group 30487",
    transform: "translate(-608.594 -57.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8330",
    "data-name": "Rectangle 8330",
    width: 15.811,
    height: 13.835,
    rx: 2,
    transform: "translate(609.094 63.743)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11682",
    "data-name": "Path 11682",
    d: "M4.869,12.1V9.657A1.674,1.674,0,0,1,6.543,7.983H17.32a1.674,1.674,0,0,1,1.674,1.674V12.1",
    transform: "translate(605.068 51.893)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11683",
    "data-name": "Path 11683",
    d: "M11.437,5.528h0a.849.849,0,0,1-.849-.849V2.625a.849.849,0,1,1,1.7,0V4.679A.849.849,0,0,1,11.437,5.528Z",
    transform: "translate(601.72 56.224)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11684",
    "data-name": "Path 11684",
    d: "M29.984,5.528h0a.849.849,0,0,1-.849-.849V2.625a.849.849,0,0,1,1.7,0V4.679A.849.849,0,0,1,29.984,5.528Z",
    transform: "translate(590.86 56.224)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11685",
    "data-name": "Path 11685",
    d: "M0,1.676,1.676,0,5.644,3.969",
    transform: "translate(616.407 66.52) rotate(45)",
    fill: "rgba(0,0,0,0)",
    stroke: "#6f6f6f",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup30487);
export default __webpack_public_path__ + "static/media/group-30487.ed4773f2c6f85f30ffdee7eeb6a35270.svg";
export { ForwardRef as ReactComponent };